import Link from '@decisiv/ui-components/lib/components/Link';

import TextCell from 'components/TextCell';
import ROUTE_NAMES from 'setup/Routing/routeNames';

interface TeamTabCountCellProps {
  teamId: string;
  /** One of the Team page `TEAM_TABS`. */
  tab: 'assets' | 'depots' | 'accounts';
  count?: number | null;
}

/**
 * PD-5874: an All Teams count that opens the matching Team page tab, instead
 * of the old Accounts and Depots list pages. A zero has nothing to open.
 */
export default function TeamTabCountCell({
  teamId,
  tab,
  count,
}: TeamTabCountCellProps) {
  if (!count) return <TextCell text={String(count ?? 0)} />;

  return (
    <Link
      to={ROUTE_NAMES.forAdminManagementTeamTab(teamId, tab)}
      text={count.toLocaleString()}
    />
  );
}
